import React from 'react';
import { Trash2, FileCheck, FileClock } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

type Artifact = {
  id: number;
  version_number: string;
  updated_at: string;
  is_final: boolean; // 0 or 1
  created_by?: number; // 创建者ID
  created_by_name?: string; // 创建者名称（旧字段，兼容用）
  created_by_username?: string; // 创建者用户名（新字段）
};

type Props = {
  plans: Artifact[];
  onEnter: (mode: 'plan', id: number) => void;
  onDelete: (id: number) => void; // 🔥 New prop
};

export const PlanList: React.FC<Props> = ({ plans, onEnter, onDelete }) => {
  const { user } = useAuth();
  console.log('=== PlanList 组件 ===');
  console.log('接收的 plans 长度:', plans.length);
  console.log('当前用户信息:', user);
  
  return (
    <div className="divide-y divide-gray-100 max-h-[300px] overflow-y-auto">
      {plans.length === 0 && <div className="p-4 text-center text-gray-400 text-sm">No plans yet.</div>}
      
      {plans.map(p => (
        <div key={p.id} className="p-4 flex justify-between hover:bg-gray-50 items-center group transition-colors">
          <div className="flex items-center gap-4">
            {/* Version Circle */}
            <div className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold shrink-0 ${p.is_final ? 'bg-green-100 text-green-700' : 'bg-blue-100 text-blue-600'}`}>
              {p.version_number}
            </div>
            
            <div className="flex flex-col gap-1">
              {/* Status Badge */}
              <div className="flex items-center gap-2">
                {p.is_final ? (
                  <span className="flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider text-green-600 bg-green-50 px-1.5 py-0.5 rounded border border-green-100">
                    <FileCheck size={10}/> Final
                  </span>
                ) : (
                  <span className="flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider text-amber-600 bg-amber-50 px-1.5 py-0.5 rounded border border-amber-100">
                    <FileClock size={10}/> Draft
                  </span>
                )}
                <span className="text-xs text-gray-400">{new Date(p.updated_at).toLocaleString()}</span>
                <span className="text-xs text-gray-400 flex items-center gap-1">
                  <span className="w-1.5 h-1.5 rounded-full bg-gray-300"></span>
                  <span className="text-[11px]">Created by: {p.created_by_username || p.created_by_name || 'Unknown'}</span>
                </span>
              </div>
              {/* Delete Button - sys角色可删除任何版本；普通用户只能删除自己创建的草稿版本 */}
              {(user?.role === 'sys' || (!p.is_final && p.created_by === user?.id)) && (
                <button 
                  onClick={(e) => { e.stopPropagation(); onDelete(p.id); }}
                  className="p-1.5 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded transition-colors"
                  title="Delete Draft"
                >
                  <Trash2 size={14}/>
                </button>
              )}
            </div>
          </div>

          <div className="flex items-center gap-3 opacity-100">
            <button 
              onClick={() => onEnter('plan', p.id)} 
              className="text-xs font-medium text-blue-600 hover:text-blue-800 hover:underline"
            >
              View
            </button>
            
            
          </div>
        </div>
      ))}
    </div>
  );
};
